import { jsx } from "react/jsx-runtime";
import { c } from "react/compiler-runtime";
import Box from "@mui/material/Box";
const ComponentWrapper = (t0) => {
  const $ = c(6);
  let children;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = props;
  } else {
    children = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== children || $[4] !== props) {
    t1 = /* @__PURE__ */ jsx(Box, { ...props, children });
    $[3] = children;
    $[4] = props;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
};
export {
  ComponentWrapper as default
};
